/**
 * Theme Switcher Component
 * Allows users to switch between light, dark, and system themes
 */

import { useTheme } from 'next-themes';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Sun, Moon, Monitor } from 'lucide-react';
import { Dropdown } from '@/components/common/Dropdown';

export function ThemeSwitcher() {
  const { theme, setTheme } = useTheme();
  const { t } = useTranslation();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  const themes = [
    { value: 'light', label: t('theme.light'), icon: Sun },
    { value: 'dark', label: t('theme.dark'), icon: Moon },
    { value: 'system', label: t('theme.system'), icon: Monitor },
  ];

  const currentTheme = themes.find((th) => th.value === theme) || themes[2];

  return (
    <Dropdown
      options={themes}
      value={theme || 'system'}
      onChange={setTheme}
      triggerLabel={currentTheme.label}
      ariaLabel="Select theme"
    />
  );
}
